import { useCallback } from 'react';

import { Select } from '@/lib/base/forms/select/select';

// ── Constants (module-scope for stable references) ───────────────────────────

const SCHEDULING_TYPE_ITEMS = [
  { id: 'individual', label: 'Individual' },
  { id: 'round_robin', label: 'Round robin' },
  { id: 'collective', label: 'Collective' },
];

const SCHEDULING_TYPE_DESCRIPTIONS: Record<string, string> = {
  round_robin:
    'One available team member is automatically assigned to each booking.',
  collective:
    'Finds a time when all team members are free and adds everyone to the meeting.',
};

// ── Component ────────────────────────────────────────────────────────────────

interface SchedulingTypeFieldProps {
  value: unknown;
  onChange: (next: unknown) => void;
  disabled: boolean;
}

export function SchedulingTypeField({
  value,
  onChange,
  disabled,
}: SchedulingTypeFieldProps) {
  const handleSelectionChange = useCallback(
    (key: string | number | null) => {
      onChange(key !== null && key !== undefined ? String(key) : null);
    },
    [onChange]
  );

  const renderItem = useCallback(
    (item: { id: string; label?: string }) => (
      <Select.Item id={item.id}>{item.label}</Select.Item>
    ),
    []
  );

  const stringValue = String(value ?? '');
  const description = SCHEDULING_TYPE_DESCRIPTIONS[stringValue] ?? null;

  return (
    <div>
      <Select
        placeholder='Select scheduling type'
        size='sm'
        items={SCHEDULING_TYPE_ITEMS}
        selectedKey={value != null ? String(value) : null}
        onSelectionChange={handleSelectionChange}
        isDisabled={disabled}
        aria-label='Scheduling type'
      >
        {renderItem}
      </Select>
      {description && (
        <p className='mt-1.5 text-sm text-[var(--color-text-tertiary)]'>
          {description}
        </p>
      )}
    </div>
  );
}
